module.exports = __webpack_public_path__ + "assets/icon-portablePosts-plasticPortable.3cba18e5.svg";